import { getCurrentEnv } from 'helpers/getCurrentEnv'

import { CurrentEnvironment, TEST_ENV_QUERY_PARAM } from 'root-constants'
import { TValueOf } from 'root-types'

export type TCurrentEnvironment = TValueOf<typeof CurrentEnvironment>

type TEnvironmentFlags = {
  isProdEnvironment: boolean
  isDevEnvironment: boolean
  isStageEnvironment: boolean
  isTestEnvironment: boolean
}

export const getEnvironment = (): TEnvironmentFlags => {
  const currentEnv = getCurrentEnv()
  const searchParams = new URLSearchParams(document.location.search)

  return {
    isProdEnvironment: currentEnv === CurrentEnvironment.PROD,
    isDevEnvironment: currentEnv === CurrentEnvironment.DEV,
    isStageEnvironment: currentEnv === CurrentEnvironment.STAGE,
    isTestEnvironment: searchParams.has(TEST_ENV_QUERY_PARAM),
  }
}
